import "./nav-item-component-styles.scss";

const NavItemComponent = ({ item, itemLink, activeItem, setActiveItem }) => {
	return (
		<a
			href={itemLink}
			key={item}
			className={`nav-item-box`}
			onClick={() => setActiveItem(item)}
		>
			<li className={`nav-item ${activeItem === item ? `active` : ``}`}>
				{item}
			</li>
		</a>
	);
};

export default NavItemComponent;